module.exports = __webpack_public_path__ + "static/ProdLeft_2-23c0362e86e407fbc3040694a315e3db.png";